module.exports = __webpack_public_path__ + "/login_ui/img/pw-c0deb8bf56e85825867321281c01abcf.svg";